import React, { Component } from 'react'
import BtnText from 'components/BtnText'
import PropTypes from 'prop-types'
import { rootPath, createMarkup, relativizeURL, randomNumber } from 'lib/Utils'
import './index.scss'
import { TweenMax, Power0, Power2, Power3 } from 'gsap'
import TimelineMax from 'gsap/TimelineMax'
import WPAPI from 'wpapi'
import SplitText from 'lib/SplitText'
import $ from 'jquery'

class SceneCopy extends Component {
  constructor (props) {
    super(props)
    let selectedServiceObject = this.props.listedServices.find((service) => {
      return service.ID === this.props.selectedService
    })

    let selectedServiceIndex = this.props.listedServices.findIndex((service) => {
      return service.ID === this.props.selectedService
    })

    this.state = {
      allowNavigation: true,
      introText: null,
      serviceTitle: selectedServiceObject ? selectedServiceObject.title : null,
      serviceURL: selectedServiceObject ? selectedServiceObject.url : null,
      serviceIndex: selectedServiceIndex !== -1 ? selectedServiceIndex + 1 : null
    }
  }

  componentDidMount () {
    // Get intro text from site
    const wp = new WPAPI({
      endpoint: `${rootPath}/wp-json`
    })

    wp.options = wp.registerRoute('acf/v2', 'options/?(?P<field>[\\w\\-\\_]+)?')

    wp.options().field('intro_text').get()
      .then((data) => {
        this.setState({ introText: data.intro_text })
      })
  }

  componentDidUpdate (prevProps, prevState) {
    if (((prevState.serviceTitle !== this.state.serviceTitle)) && this.sceneCopyEl) {
      var splitText = new SplitText($(this.sceneCopyEl).find('.scene-copy__text'), { type: 'chars, lines', charsClass: 'char' })
      const timeline = new TimelineMax()
      timeline.fromTo(this.sceneCopyEl, 0.75, { opacity: 0 }, { opacity: 1, ease: Power0.easeNone }, 0.25)
      splitText.chars.forEach(function (element, i) {
        timeline.fromTo(element, 1, { rotationX: randomNumber(-100, 100) + 'deg' }, { rotationX: '0deg', ease: Power3.easeOut }, 0)
        // timeline.fromTo(element, 1, { rotationX: (100 - ((i % 2) * 200)) + 'deg' }, { rotationX: 0, ease: Power3.easeOut }, 0)
      })
    }
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.selectedService !== this.props.selectedService && this.state.allowNavigation) {
      // This is to avoid momentarily displaying the scene copy of the last service in the state,
      // when transitioning from no service to a service.
      // It happened when doing:
      // -> Home -> Select Service -> Read More on Service
      // -> Back Home -> Select Service other than the previously selected
      if (this.sceneCopyEl) {
        const timeline = new TimelineMax({ onComplete: () => {
          if (nextProps.selectedService === null) {
            this.setState({
              serviceTitle: null,
              serviceURL: null
            })
            return
          }

          let selectedServiceObject = this.props.listedServices.find((service) => {
            return service.ID === this.props.selectedService
          })

          if (!selectedServiceObject) {
            return
          }

          let selectedServiceIndex = this.props.listedServices.findIndex((service) => {
            return service.ID === this.props.selectedService
          })

          this.setState({
            serviceTitle: selectedServiceObject.title,
            serviceURL: selectedServiceObject.url,
            serviceIndex: selectedServiceIndex + 1
          })
        } })

        timeline.fromTo(this.sceneCopyEl, 0.75, { opacity: 1 }, { opacity: 0, ease: Power0.easeNone }, 0)
        $(this.sceneCopyEl).find('.scene-copy__text .char').get().forEach(function (element, i) {
          // timeline.fromTo(element, 1, { rotationX: 0 }, { rotationX: (100 - ((i % 2) * 200)) + 'deg', ease: Power3.easeIn }, 0)
          timeline.fromTo(element, 1, { rotationX: '0deg' }, { rotationX: randomNumber(-100, 100) + 'deg', ease: Power3.easeIn }, 0)
        })
      }
    }
  }

  componentWillAppear (callback) {
    TweenMax.fromTo(this.sceneCopyEl, 0.6, { opacity: 0 }, { opacity: 1, ease: Power0.easeNone, onComplete: callback, delay: 0.6 })
  }

  componentWillEnter (callback) {
    TweenMax.fromTo(this.sceneCopyEl, 0.6, { opacity: 0 }, { opacity: 1, ease: Power0.easeNone, onComplete: callback, delay: 0.6 })
  }

  componentWillLeave (callback) {
    TweenMax.fromTo(this.sceneCopyEl, 0.6, { opacity: 1 }, { opacity: 0, ease: Power0.easeNone, onComplete: callback })
  }

  renderSceneCopy () {
    if (this.state.introText && this.state.serviceTitle === null) {
      return (
        <div className='scene-copy__inner'>
          <div className='scene-copy__text' dangerouslySetInnerHTML={createMarkup(this.state.introText)} />
          <BtnText
            className='scene-copy__button btn-text--lined'
            onClickCallback={() => this.props.onClickCallback(this.props.listedServices[0].ID)}>
            Swipe to explore
          </BtnText>
        </div>
      )
    } else if (this.state.serviceTitle && this.state.serviceURL) {
      return (
        <div className='scene-copy__inner'>
          <div className='scene-copy__counter'>{this.state.serviceIndex.toString().padStart(2, '0')}</div>
          <div className='scene-copy__text' dangerouslySetInnerHTML={createMarkup(this.state.serviceTitle)} />
          <BtnText
            className='scene-copy__button btn-text--lined'
            to={relativizeURL(this.state.serviceURL)}>Read More</BtnText>
        </div>
      )
    }
  }

  render () {
    return (
      <div ref={(el) => { this.sceneCopyEl = el }} className='scene-copy'>
        {this.renderSceneCopy()}
      </div>
    )
  }
}

SceneCopy.propTypes = {
  listedServices: PropTypes.array,
  selectedService: PropTypes.number,
  onClickCallback: PropTypes.func
}

export default SceneCopy



// WEBPACK FOOTER //
// ./src/components/SceneCopy/index.js